import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "../lib/pos";

export const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=unauth, obj=auth
  useEffect(() => {
    axios.get(`${API}/auth/me`).then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);
  const login = async (email, password, opts = {}) => {
    const r = await axios.post(`${API}/auth/login`, {
      email,
      password,
      remember_me: !!opts.remember_me,
      captcha_id: opts.captcha_id || null,
      captcha_answer: opts.captcha_answer || null,
    });
    setUser(r.data);
    return r.data;
  };
  const logout = async () => {
    try { await axios.post(`${API}/auth/logout`); } catch (_) { /* ignore */ }
    setUser(false);
  };
  return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
}
